
import { defineComponent } from "vue";
import AppInstallBanner from "./components/AppInstallBanner.vue";

export default defineComponent({
  components: {
    AppInstallBanner,
  },
});
